import { chartColours } from "../../themes/colours";
import { gis2QueryUrl } from "../../utils/urls.js"

import { cultureLayerDefsCim } from './cultureLayerDefsCim'

const creativeEnterpriseLayer = {
  layer: {
    id: "creative-enterprise",
    type: "fill",
    paint: {
      "fill-color": chartColours.ldnDkPink,
      "fill-opacity": 0.7,
      "fill-outline-color": "#000000",
    },
    layout: {
      visibility: "none",
    },
  },
  source: {
    id: "creative-enterprise",
    type: "geojson",
    data: gis2QueryUrl("planning_data_map_02", 304),
  },
  labels: {
    parent: "Creative Enterprise Zones",
  },
  filters: {
    filterByChildren: false,
  },
  filterBySelectedRegion: true,
  category: "culture",
  popupAttributes: ["sitename"],
  info: {
    shortDescription:
      "Creative Enterprise Zones are a Mayoral initiative to designate areas of London where artists and creative businesses can find permanent affordable space to work.",
    longDescriptionTitle: "Creative Enterprise Zones Layer Information",
    longDescription:
      "Creative Enterprise Zones are a Mayoral initiative to designate areas of London where artists and creative businesses can find permanent affordable space to work; are supported to start-up and grow; and where local people are helped to learn creative sector skills and access pathways to employment. https://www.london.gov.uk/what-we-do/arts-and-culture/culture-and-good-growth/explore-creative-enterprise-zones/about-creative-enterprise-zones",
  },
}

export const cultureLayersBase = {
}

export const cultureLayersPoly = {
   "creative-enterprise":  creativeEnterpriseLayer,
}

export const cultureLayersPoint = {
  ...cultureLayerDefsCim,
}